/** Traductions page paramètres (FR / AR) */
export const settingsPageFr = {
  pageTitle: 'Paramètres',
  pageDesc: 'Devise, apparence, imprimantes, tolérance, santé du stock et identité visuelle.',
  nav: {
    currency: { label: 'Devise', title: 'Devise', desc: 'Devise affichée dans l\'application et les documents.' },
    appearance: {
      label: 'Apparence',
      title: 'Apparence',
      desc: 'Thème de couleurs et densité de l\'interface.',
    },
    printers: {
      label: 'Imprimantes',
      title: 'Imprimantes par tâche',
      desc: 'Reçu thermique, documents A4/A5 et étiquettes — une machine par rôle.'
    },
    tolerance: { label: 'Tolérance', title: 'Écarts et tolérance', desc: 'Seuil par défaut pour les écarts de caisse et alertes.' },
    inventory: {
      label: 'Stock',
      title: 'Santé du stock',
      desc: 'Contrôle des écarts entre lots, mouvements et instantanés, et mode sécurisé.'
    },
    business: {
      label: 'Entreprise',
      title: 'Entreprise',
      desc: 'Logo, capital d\'ouverture, immobilisations et offre cloud.'
    }
  },
  currencyTitle: 'Devise',
  currencyDesc: 'Devise affichée dans l\'application et les documents',
  oldCurrency: 'Ancienne devise',
  newCurrency: 'Nouvelle devise',
  currencyNote1: 'Mise à jour automatique des prix',
  currencyNote2: 'Rapports dans la nouvelle devise',
  currencyNote3: 'Sessions précédentes conservées',
  currencyMroName: 'Ouguiya (MRO)',
  currencyMruName: 'Ouguiya (MRU)',
  currencySelected: 'Sélectionné',
  currencyConversion: '1 MRU = 10 MRO',
  appearanceThemeTitle: 'Thème',
  appearanceThemeDesc: 'Claire, sombre, ou selon le système. Remap des couleurs uniquement — pas de nouvelles mises en page.',
  appearanceTheme_light: 'Clair',
  appearanceTheme_dark: 'Sombre',
  appearanceTheme_system: 'Système',
  appearanceThemeHint_light: 'Par défaut — identité AMAN actuelle.',
  appearanceThemeHint_dark: 'Canevas sombre pour les écrans de gestion.',
  appearanceThemeHint_system: 'Suit les préférences d’affichage de l’appareil.',
  appearanceThemeNote: 'Caisse POS et cuisine restent en thème clair (constitution métier).',
  appearanceDensityTitle: 'Densité',
  appearanceDensityDesc: 'Espacement des tableaux, boutons et panneaux. « Automatique » s\'adapte à la taille de l\'écran.',
  appearanceDensity_auto: 'Automatique',
  appearanceDensity_comfortable: 'Confortable',
  appearanceDensity_compact: 'Compact',
  appearanceDensity_enterprise: 'Enterprise',
  appearanceDensityHint_auto: 'Recommandé — densité et texte selon fenêtre et contenu.',
  appearanceDensityHint_comfortable: 'Équilibre fixe pour la gestion.',
  appearanceDensityHint_compact: 'Plus de lignes visibles — listes et POS.',
  appearanceDensityHint_enterprise: 'Grands écrans — panneaux plus aérés.',
  appearanceSelected: 'Sélectionné',
  appearanceTouchNote: 'Sur tablette ou écran tactile, la hauteur minimale des contrôles (44 px) s\'applique automatiquement.',
  colBucketId: 'ID',
  bucketActive: '(actif)',
  toleranceTitle: 'Écarts et tolérance',
  toleranceDesc: 'Seuil par défaut pour les écarts de caisse',
  systemEnabled: 'Système activé',
  systemDisabled: 'Système désactivé',
  defaultTolerance: 'Tolérance par défaut',
  inventoryLedger: {
    title: 'Santé du stock',
    desc: 'Compare lots, mouvements et instantanés. En cas d’écart, active le mode sécurisé. Permet de recalculer les lots et de figer le coût d’achat des ventes.',
    runScan: 'Analyser',
    scanning: 'Analyse…',
    reproject: 'Recalculer les lots',
    reprojectConfirm:
      'Recalculer remplace les quantités restantes des lots à partir des mouvements de stock. Continuer ?',
    softFreezeSales: 'Figer le coût des ventes',
    softFreezeOk: 'Coût des ventes figé pour {{frozen}} vente(s) · {{pass}} passage(s)',
    softFreezeNone: 'Aucune vente à figer (déjà figées ou sans données de coût)',
    softFreezePartial:
      'Figement partiel : {{frozen}} vente(s) en {{pass}} passage(s) — relancer si besoin',
    softFreezePasses: 'Passages',
    softFreezeDrained: 'terminé',
    enrichActors: 'Compléter opérateur / séance',
    enrichActorsConfirm:
      'Complète les opérateurs et séances manquants à partir des ventes et achats liés. Ne modifie ni les quantités ni l’ordre des mouvements. Continuer ?',
    enrichActorsDetail:
      '{{enriched}} mouvement(s) complété(s) / {{scanned}} parcouru(s) — restants incomplets {{missing}}',
    frozenNow: 'Nouvellement figés',
    alreadyFrozen: 'Déjà figés',
    skipped: 'Ignorés',
    considered: 'Ventes examinées',
    reprojectDetail: 'Recalcul ({{movements}} mouvements) — {{status}}',
    reprojectStatusOk: 'réussi',
    reprojectStatusPartial: 'partiel',
    reprojectBeforeAfter:
      'Écarts avant → après : lots / mouvements {{beforeMoves}} → {{afterMoves}} ; lots / instantanés {{beforeSnaps}} → {{afterSnaps}}',
    reprojectLotsCount: '{{count}} lot(s) après recalcul',
    reprojectErrors: 'Erreurs de recalcul : {{detail}}',
    safeModeOff: 'Mode sécurisé stock : inactif',
    safeModeOn: 'Mode sécurisé stock : actif ({{reason}})',
    resultOk: 'Aucun écart détecté',
    resultFail: '{{count}} écart(s) détecté(s)',
    lotsVsMoves: 'Lots par rapport aux mouvements',
    lotsVsSnaps: 'Lots par rapport aux instantanés',
    samples: 'Exemples',
    hint: 'Analyse automatique au démarrage et à l’ouverture de ce panneau. Relancez manuellement après une réparation ou si le stock paraît incohérent. Le recalcul réécrit les lots à partir des mouvements (autorisé en mode sécurisé).'
  },
  businessStores: {
    title: 'Magasins',
    desc: 'Organisation spatiale : entreprise → magasin → emplacement. Le magasin actif guide la réception, les transferts et le stock.',
    add: 'Ajouter',
    refresh: 'Actualiser',
    loading: 'Chargement…',
    empty: 'Aucun magasin',
    idPh: 'code (ex. filiale_b)',
    namePh: 'Nom affiché',
    colId: 'Code',
    colName: 'Nom',
    colFlags: 'Rôle',
    colActions: 'Actions',
    flagDefault: 'Défaut',
    flagActive: 'Actif',
    setDefault: 'Défaut',
    setActive: 'Activer',
    idRequired: 'Code requis',
    saveFailed: 'Enregistrement impossible',
    noBusiness: 'Entreprise non sélectionnée',
    hint: 'Le magasin actif est mémorisé pour l’entreprise. Les emplacements (Principal, entrepôt…) restent sous chaque magasin.'
  },
  printers: {
    title: 'Imprimantes par tâche',
    desc: 'Assignez une imprimante physique à chaque type d’impression. Testez avant d’encaisser.',
    refresh: 'Actualiser',
    loading: 'Chargement…',
    noPrinters: 'Aucune imprimante physique détectée (PDF / XPS exclus).',
    colRole: 'Tâche',
    colPrinter: 'Imprimante',
    colStatus: 'État',
    colActions: 'Actions',
    role_receipt: 'Reçu caisse (thermique)',
    role_document: 'Documents (facture A4/A5)',
    role_label: 'Étiquettes prix',
    paperHint: 'Format : {{hint}}',
    useAuto: 'Automatique (documents / étiquettes : hors thermique caisse)',
    notFound: 'absent',
    statusOk: 'Prête',
    statusFallback: 'Via reçu caisse',
    statusMissing: 'Introuvable',
    statusOffline: 'Hors ligne',
    statusUnassigned: 'Non assignée',
    viaReceipt: 'Effectif : reçu « {{name}} »',
    test: 'Tester',
    testing: 'Test…',
    savedTitle: 'Imprimante enregistrée',
    savedDetail: 'Rôle « {{role}} » mis à jour',
    testOkTitle: 'Test imprimé',
    testOkDetail: 'Page de test — {{role}}',
    testOkViaReceipt: 'Page de test — {{role}} via reçu « {{name}} »',
    testOkAuto: 'Page de test — {{role}} (auto, hors thermique pour docs/étiquettes)',
    testViaReceiptTitle: 'Test via reçu caisse',
    testViaReceiptDetail:
      '« {{role}} » n’a pas d’imprimante propre — impression sur le reçu « {{name}} ».',
    testAutoTitle: 'Test en auto',
    testAutoDetail:
      '« {{role}} » sans assignation — découverte auto (docs/étiquettes n’utilisent pas le thermique POS).',
    testFailTitle: 'Échec du test',
    testFailDetail: 'Vérifiez la connexion et le pilote Windows',
    assignRejected: 'Imprimante non valide (virtuelle ou inconnue)',
    hint: 'PDF virtuel interdit. Factures/étiquettes : assignez une imprimante A4/feuille — pas de bascule silencieuse vers le reçu thermique. Sans assignation : auto (hors POS thermique). Échec = même rôle uniquement. Electron requis.'
  },
  off: 'Off',
  on: 'On',
  logoTitle: 'Logo entreprise',
  logoDesc: 'Affiché sur les factures et l\'interface',
  logoAlt: 'Logo',
  logoFormats: 'PNG, JPG, SVG — 2 Mo max',
  uploading: 'Envoi…',
  upload: 'Télécharger',
  delete: 'Supprimer',
  invalidFileType: 'Type de fichier invalide',
  selectImageFile: 'Veuillez sélectionner un fichier image',
  fileTooLarge: 'Fichier trop volumineux',
  maxFileSize: 'La taille maximale du fichier est de 2 Mo',
  noFileSelected: 'Aucun fichier sélectionné',
  selectFileToUpload: 'Veuillez sélectionner un fichier à télécharger',
  logoUploadSuccess: 'Logo téléchargé avec succès',
  logoUploadSuccessDetail: 'Le logo a été enregistré dans l\'application et Supabase',
  logoUploadFailed: 'Échec du téléchargement du logo',
  logoUploadError: 'Une erreur s\'est produite lors du téléchargement du logo',
  unexpectedError: 'Une erreur inattendue s\'est produite',
  confirmDeleteLogo: 'Êtes-vous sûr de vouloir supprimer le logo ?',
  logoDeleteSuccess: 'Logo supprimé avec succès',
  logoDeleteSuccessDetail: 'Le logo a été supprimé de l\'application et Supabase',
  logoDeleteFailed: 'Échec de la suppression du logo',
  logoDeleteError: 'Une erreur s\'est produite lors de la suppression du logo',
  logoPreviewHint: 'Cliquez pour changer le logo',
  changeLogo: 'Changer le logo',
  chooseFile: 'Choisir un fichier',
  dataSourceActivated: 'Source de données activée: {{id}}',
  dataSourceActivatedReload: 'Source {{id}} activée — rechargement…',
  sectionLoading: 'Chargement…',
  invoiceResetTitle: 'Réinitialiser N° facture',
  invoiceResetDesc:
    'Remet les compteurs facture / consolidée à 0 uniquement s’il n’existe plus aucune facture — prochaine : 001.',
  invoiceResetRun: 'Remettre à 001 (si vide)',
  invoiceResetRunning: 'Réinitialisation…',
  invoiceResetSuccess: 'Compteur facture remis à zéro — prochaine : {{number}}',
  invoiceResetBlockedSales:
    'Impossible : {{count}} vente(s) réelle(s) détectée(s). Le N° facture n’a pas été modifié.',
  invoiceResetBlockedInvoices:
    'Impossible : {{count}} facture(s) encore présentes. Utilisez « Aligner » ou « Compact ».',
  invoiceResetNoBusiness: 'Aucune entreprise active',
  invoiceResetFailed: 'Échec de la réinitialisation du N° facture',
  sequenceToolsTitle: 'Numéros Achat / Vente / Facture',
  sequenceToolsDesc:
    'Aligner = prochaine = max existant + 1. Remettre à 001 = seulement si vide. Compact = remplir les trous (1…N) avec remap sécurisé — uniquement via ces boutons.',
  sequenceToolsRunning: 'Traitement…',
  sequenceAlignRun: 'Aligner les compteurs',
  sequenceAlignSuccess: 'Compteurs alignés — prochaines : {{next}}',
  sequenceAlignFailed: 'Échec de l’alignement des compteurs',
  sequenceCompactRun: 'Compact (combler les trous)',
  sequenceCompactConfirm:
    'Compact va renuméroter Achat, Vente et Factures sans trous (1…N) et mettre à jour lots / factures liées. Continuer vers l’aperçu ?',
  sequenceCompactApplyConfirm:
    '{{count}} numéro(s) à changer. Prochaines après compact : {{next}}. Appliquer maintenant ?',
  sequenceCompactNothing: 'Rien à compact : déjà sans trous ou aucun document.',
  sequenceCompactSuccess: 'Compact terminé ({{count}} changements) — prochaines : {{next}}',
  sequenceCompactFailed: 'Échec du compact des numéros',
  openingCapitalTitle: 'Capital d\'ouverture',
  openingCapitalDesc:
    'Apport initial total du propriétaire (optionnel) : liquidités + immobilisations. Un seul montant.',
  openingCapitalAmount: 'Montant',
  openingCapitalDescription: 'Description (optionnel)',
  openingCapitalSave: 'Enregistrer le capital',
  openingCapitalSaved: 'Capital d\'ouverture enregistré',
  openingCapitalHint:
    'Exemple : capital 1 000 000 dont auto 250 000 → saisir 1 000 000 ici et l\'auto dans Immobilisations. Les marchandises restent via Achats.',
  openingCapitalRemaining:
    'Trésorerie d\'ouverture restante (hors immobilisations) : {{amount}} — n\'entre pas dans le solde du tableau de bord tant qu\'il n\'y a pas de ventes.',
  fixedAssetsTitle: 'Immobilisations',
  fixedAssetsDesc: 'Biens durables : véhicule, bureau, rayonnages, matériel (optionnel).',
  fixedAssetName: 'Nom',
  fixedAssetCategory: 'Catégorie',
  fixedAssetAmount: 'Valeur',
  fixedAssetAdd: 'Ajouter',
  fixedAssetSave: 'Enregistrer les immobilisations',
  fixedAssetSaved: 'Immobilisations enregistrées',
  fixedAssetEmpty: 'Aucune immobilisation',
  fixedAssetTotal: 'Total immobilisations',
  fixedAssetCatVehicle: 'Véhicule',
  fixedAssetCatFurniture: 'Mobilier / rayonnages',
  fixedAssetCatBuilding: 'Local / bureau',
  fixedAssetCatEquipment: 'Équipement',
  fixedAssetCatOther: 'Autre',
  openingCapitalFixedWarning:
    'Les immobilisations dépassent le capital d\'ouverture — augmentez le capital ou réduisez les immobilisations.',
  cloudSyncTitle: 'Synchronisation cloud',
  cloudSyncDesc:
    'Synchronisation fully automatic: dès que Mirror/Hybrid est actif et vous êtes en ligne, toutes les données partent vers Supabase (sans photos produits).',
  cloudSyncPlan: 'Offre actuelle',
  cloudSyncPlanNone: 'Local uniquement — activez Mirror ou Hybrid pour la sauvegarde cloud auto',
  cloudSyncPlanMirror: 'Cloud Mirror — sync auto de toutes les données (sauf images produits)',
  cloudSyncPlanHybrid:
    'Hybrid — Mirror auto + catalogue multi-appareils (sync + temps réel)',
  cloudSyncScope:
    'Aucun bouton requis : login, démarrage, online et chaque modification local → push Supabase automatique. Seul le logo image est cloud ; photos produits restent locales.',
  cloudSyncContactAdmin: 'Pour activer Cloud Mirror ou Hybrid, contactez l\'administrateur AMAN.',
  cloudOutboxTitle: 'File d\'attente cloud (Outbox)',
  cloudOutboxSummary:
    'En attente: {{pending}} · Reporté (plan): {{deferred}} · En cours: {{processing}} · Échec: {{failed}} · OK: {{done}}',
  cloudOutboxIdle: 'Rien en attente — file vide ou tout synchronisé.',
  cloudOutboxUnavailable: 'État outbox indisponible (IndexedDB).',
  cloudOutboxRefresh: 'Actualiser le statut',
  cloudOutboxDrain: 'Forcer le envoi',
  cloudOutboxRetry: 'Réessayer les échecs',
  cloudOutboxWorking: 'Sync…',
  cloudOutboxDrainDone: 'Drain outbox terminé',
  cloudOutboxDrainFailed: 'Échec du drain outbox',
  cloudOutboxRetryDone: '{{count}} entrée(s) remises en file',
  cloudOutboxRetryFailed: 'Échec de la reprise outbox',
  restaurantTablesTitle: 'Tables restaurant',
  restaurantTablesDesc:
    'Tables pour le service Sur place (POS). Les tables inactives n’apparaissent pas au sol.',
  restaurantTablesAdd: 'Ajouter une table',
  restaurantTablesLabel: 'Nom',
  restaurantTablesSeats: 'Couverts',
  restaurantTablesActive: 'Active',
  restaurantTablesSave: 'Enregistrer les tables',
  restaurantTablesSaved: 'Tables enregistrées',
  restaurantTablesEmpty: 'Aucune table — un jeu T1–T12 sera créé au premier chargement restaurant.',
  restaurantTablesRemove: 'Retirer',
  cloudLinkStatus: 'Lien cloud',
  cloudLinkLinked: 'Compte lié à Supabase — visible pour l\'admin',
  cloudLinkLocalOnly: 'Local uniquement — pas encore dans Supabase',
  cloudUpgradeHint:
    'Crée le compte Auth + demande admin dans Supabase. Ensuite l\'admin peut approuver et activer Mirror ou Hybrid. Les données locales restent intactes.',
  cloudUpgradePassword: 'Mot de passe du compte (confirmation)',
  cloudUpgradePasswordPlaceholder: 'Mot de passe de connexion',
  cloudUpgradeRun: 'Upgrade Cloud',
  cloudUpgradeRunning: 'Connexion au cloud…',
  cloudUpgradeSuccess: 'Compte cloud créé — en attente d\'approbation admin',
  cloudUpgradePendingEmail:
    'Compte Auth créé — confirmez l\'e-mail si demandé, puis l\'admin pourra approuver',
  cloudUpgradeAlreadyLinked: 'Ce compte est déjà lié au cloud',
  cloudUpgradeFailed: 'Échec de l\'upgrade cloud',
  cloudUpgradeErrOffline: 'Connexion Internet requise — vérifiez le réseau / VPN, puis réessayez',
  cloudUpgradeErrPassword: 'Mot de passe incorrect',
  cloudUpgradeErrPasswordRequired: 'Saisissez le mot de passe du compte',
  cloudUpgradeErrConfig: 'Supabase non configuré dans l\'application',
  cloudUpgradeErrNotFound:
    'Compte local introuvable — reconnectez-vous avec le compte entreprise, puis réessayez l\'upgrade',
  cloudUpgradeErrIdentity:
    'E-mail ou nom d\'utilisateur manquant sur le compte local — complétez l\'inscription / le profil',
  cloudPlanRefresh: 'Actualiser l\'offre cloud',
  cloudPlanRefreshing: 'Actualisation…',
  cloudPlanRefreshed: 'Offre cloud mise à jour depuis Supabase',
  cloudPlanRefreshFailed: 'Impossible d\'actualiser l\'offre cloud'
};

export const settingsPageAr = {
  pageTitle: 'الإعدادات',
  pageDesc: 'إعدادات العملة والمظهر والطابعات والتسامح وصحة المخزون وهوية المؤسسة.',
  nav: {
    currency: { label: 'العملة', title: 'العملة', desc: 'العملة المعروضة في التطبيق والمستندات.' },
    appearance: {
      label: 'المظهر',
      title: 'المظهر',
      desc: 'سمة الألوان وكثافة الواجهة.',
    },
    printers: {
      label: 'الطابعات',
      title: 'طابعات حسب المهمة',
      desc: 'إيصال حراري ومستندات A4/A5 وملصقات — جهاز لكل دور.'
    },
    tolerance: { label: 'التسامح', title: 'التسامح والفروقات', desc: 'الحد الافتراضي لفروقات الصندوق والتنبيهات.' },
    inventory: {
      label: 'المخزون',
      title: 'صحة المخزون',
      desc: 'فحص الفروقات بين اللوتات والحركات واللقطات، ووضع الأمان.'
    },
    business: {
      label: 'المؤسسة',
      title: 'المؤسسة',
      desc: 'الشعار ورأس المال والأصول الثابتة وعرض السحابة.'
    }
  },
  currencyTitle: 'العملة',
  currencyDesc: 'اختر العملة الأساسية للنظام',
  oldCurrency: 'العملة القديمة',
  newCurrency: 'العملة الجديدة',
  currencyNote1: 'تحديث الأسعار تلقائياً',
  currencyNote2: 'التقارير بالعملة الجديدة',
  currencyNote3: 'الجلسات السابقة محفوظة',
  currencyMroName: 'أوقية (MRO)',
  currencyMruName: 'أوقية (MRU)',
  currencySelected: 'محدد',
  currencyConversion: '1 MRU = 10 MRO',
  appearanceThemeTitle: 'السمة',
  appearanceThemeDesc: 'فاتح أو داكن أو حسب النظام. إعادة ربط الألوان فقط — بدون تخطيط جديد.',
  appearanceTheme_light: 'فاتح',
  appearanceTheme_dark: 'داكن',
  appearanceTheme_system: 'النظام',
  appearanceThemeHint_light: 'الافتراضي — هوية أمان الحالية.',
  appearanceThemeHint_dark: 'خلفية داكنة لشاشات الإدارة.',
  appearanceThemeHint_system: 'يتبع تفضيلات عرض الجهاز.',
  appearanceThemeNote: 'نقطة البيع والمطبخ يبقيان بالسمة الفاتحة (دستور المهنة).',
  appearanceDensityTitle: 'الكثافة',
  appearanceDensityDesc: 'تباعد الجداول والأزرار واللوحات. «تلقائي» يتكيّف مع حجم الشاشة.',
  appearanceDensity_auto: 'تلقائي',
  appearanceDensity_comfortable: 'مريح',
  appearanceDensity_compact: 'مضغوط',
  appearanceDensity_enterprise: 'Enterprise',
  appearanceDensityHint_auto: 'موصى به — الكثافة والنص حسب النافذة والمحتوى.',
  appearanceDensityHint_comfortable: 'توازن ثابت للإدارة.',
  appearanceDensityHint_compact: 'المزيد من الصفوف — القوائم ونقطة البيع.',
  appearanceDensityHint_enterprise: 'شاشات كبيرة — لوحات أكثر اتساعاً.',
  appearanceSelected: 'محدد',
  appearanceTouchNote: 'على الجهاز اللوحي أو الشاشة اللمسية، يُطبَّق ارتفاع 44px تلقائياً للأزرار.',
  colBucketId: 'المعرف',
  bucketActive: '(نشط)',
  toleranceTitle: 'نظام التسامح',
  toleranceDesc: 'حد الفروقات الافتراضي للصندوق',
  systemEnabled: 'النظام مفعّل',
  systemDisabled: 'النظام معطّل',
  defaultTolerance: 'التسامح الافتراضي',
  inventoryLedger: {
    title: 'صحة المخزون',
    desc: 'مقارنة اللوتات والحركات واللقطات. عند الانحراف يُفعَّل وضع الأمان. يتيح إعادة حساب اللوتات وتجميد تكلفة المبيعات.',
    runScan: 'فحص',
    scanning: 'جاري الفحص…',
    reproject: 'إعادة حساب اللوتات',
    reprojectConfirm:
      'إعادة الحساب تستبدل الكميات المتبقية للوتات انطلاقاً من حركات المخزون. المتابعة؟',
    softFreezeSales: 'تجميد تكلفة المبيعات',
    softFreezeOk: 'تم تجميد تكلفة {{frozen}} عملية بيع · {{pass}} دورة',
    softFreezeNone: 'لا مبيعات للتجميد (مُجمَّدة مسبقاً أو بلا بيانات تكلفة)',
    softFreezePartial:
      'تجميد جزئي: {{frozen}} في {{pass}} دورة — أعد التشغيل إن لزم',
    softFreezePasses: 'الدورات',
    softFreezeDrained: 'اكتمل',
    enrichActors: 'إكمال المشغّل / الجلسة',
    enrichActorsConfirm:
      'يملأ بيانات المشغّل والجلسة الناقصة من المبيعات والمشتريات المرتبطة. لا يغيّر الكميات ولا ترتيب الحركات. المتابعة؟',
    enrichActorsDetail:
      '{{enriched}} حركة مُكمَّلة / {{scanned}} مُراجعة — ناقص متبقّي {{missing}}',
    frozenNow: 'مُجمَّد حديثاً',
    alreadyFrozen: 'مُجمَّد مسبقاً',
    skipped: 'متجاهَل',
    considered: 'المبيعات المفحوصة',
    reprojectDetail: 'إعادة الحساب ({{movements}} حركة) — {{status}}',
    reprojectStatusOk: 'نجاح',
    reprojectStatusPartial: 'جزئي',
    reprojectBeforeAfter:
      'الانحراف قبل → بعد: لوت/حركات {{beforeMoves}} → {{afterMoves}} ؛ لوت/لقطات {{beforeSnaps}} → {{afterSnaps}}',
    reprojectLotsCount: '{{count}} لوت بعد إعادة الحساب',
    reprojectErrors: 'أخطاء إعادة الحساب: {{detail}}',
    safeModeOff: 'وضع أمان المخزون: غير مفعّل',
    safeModeOn: 'وضع أمان المخزون: مفعّل ({{reason}})',
    resultOk: 'لا انحرافات',
    resultFail: 'تم اكتشاف {{count}} انحراف(ات)',
    lotsVsMoves: 'اللوتات مقابل الحركات',
    lotsVsSnaps: 'اللوتات مقابل اللقطات',
    samples: 'أمثلة',
    hint: 'فحص تلقائي عند التشغيل وفتح هذه اللوحة. شغّل يدوياً بعد الإصلاح أو عند شك في المخزون. إعادة الحساب تكتب اللوتات من الحركات (مسموح في وضع الأمان).'
  },
  businessStores: {
    title: 'المتاجر',
    desc: 'التنظيم المكاني: المؤسسة → المتجر → الموقع. المتجر النشط يوجّه الاستلام والنقل والمخزون.',
    add: 'إضافة',
    refresh: 'تحديث',
    loading: 'جاري التحميل…',
    empty: 'لا متاجر',
    idPh: 'الرمز (مثال: filiale_b)',
    namePh: 'الاسم المعروض',
    colId: 'الرمز',
    colName: 'الاسم',
    colFlags: 'الدور',
    colActions: 'إجراءات',
    flagDefault: 'افتراضي',
    flagActive: 'نشط',
    setDefault: 'افتراضي',
    setActive: 'تفعيل',
    idRequired: 'الرمز مطلوب',
    saveFailed: 'فشل الحفظ',
    noBusiness: 'لم يتم اختيار المؤسسة',
    hint: 'يُحفظ المتجر النشط للمؤسسة. تبقى المواقع (الرئيسي، المستودع…) تحت كل متجر.'
  },
  printers: {
    title: 'طابعات حسب المهمة',
    desc: 'عيّن طابعة فعليّة لكل نوع طباعة. اختبر قبل التحصيل.',
    refresh: 'تحديث',
    loading: 'جاري التحميل…',
    noPrinters: 'لا طابعة فعليّة مكتشفة (PDF / XPS مستبعدة).',
    colRole: 'المهمة',
    colPrinter: 'الطابعة',
    colStatus: 'الحالة',
    colActions: 'إجراءات',
    role_receipt: 'إيصال الصندوق (حراري)',
    role_document: 'مستندات (فاتورة A4/A5)',
    role_label: 'ملصقات الأسعار',
    paperHint: 'التنسيق: {{hint}}',
    useAuto: 'تلقائي (مستندات/ملصقات: بدون حراري الصندوق)',
    notFound: 'غير موجود',
    statusOk: 'جاهزة',
    statusFallback: 'عبر إيصال الصندوق',
    statusMissing: 'غير موجودة',
    statusOffline: 'غير متصلة',
    statusUnassigned: 'غير معيّنة',
    viaReceipt: 'الفعلي: إيصال « {{name}} »',
    test: 'اختبار',
    testing: 'اختبار…',
    savedTitle: 'تم حفظ الطابعة',
    savedDetail: 'تم تحديث الدور « {{role}} »',
    testOkTitle: 'تم طباعة الاختبار',
    testOkDetail: 'صفحة اختبار — {{role}}',
    testOkViaReceipt: 'صفحة اختبار — {{role}} عبر إيصال « {{name}} »',
    testOkAuto: 'صفحة اختبار — {{role}} (تلقائي، بدون حراري للمستندات/الملصقات)',
    testViaReceiptTitle: 'اختبار عبر إيصال الصندوق',
    testViaReceiptDetail:
      '« {{role}} » بلا طابعة خاصة — الطباعة على الإيصال « {{name}} ».',
    testAutoTitle: 'اختبار تلقائي',
    testAutoDetail:
      '« {{role}} » بلا تعيين — اكتشاف تلقائي (المستندات/الملصقات لا تستخدم حراري الصندوق).',
    testFailTitle: 'فشل الاختبار',
    testFailDetail: 'تحقق من الاتصال وبرنامج تشغيل ويندوز',
    assignRejected: 'طابعة غير صالحة (افتراضية أو غير معروفة)',
    hint: 'PDF ممنوع. الفواتير/الملصقات: عيّن طابعة A4/ورقة — لا تحويل صامت إلى إيصال حراري. بدون تعيين: تلقائي (بدون POS حراري). الفشل = نفس الدور فقط. Electron مطلوب.'
  },
  off: 'تعطيل',
  on: 'تفعيل',
  logoTitle: 'شعار المؤسسة',
  logoDesc: 'يظهر على الفواتير والواجهة',
  logoAlt: 'الشعار',
  logoFormats: 'PNG, JPG, SVG — 2 Mo max',
  uploading: 'جاري الرفع…',
  upload: 'رفع',
  delete: 'حذف',
  invalidFileType: 'نوع الملف غير صالح',
  selectImageFile: 'يرجى اختيار ملف صورة',
  fileTooLarge: 'حجم الملف كبير جداً',
  maxFileSize: 'الحد الأقصى لحجم الملف هو 2 ميجابايت',
  noFileSelected: 'لم يتم اختيار ملف',
  selectFileToUpload: 'يرجى اختيار ملف للتحميل',
  logoUploadSuccess: 'تم رفع الشعار بنجاح',
  logoUploadSuccessDetail: 'تم حفظ الشعار في التطبيق و Supabase',
  logoUploadFailed: 'فشل رفع الشعار',
  logoUploadError: 'حدث خطأ أثناء رفع الشعار',
  unexpectedError: 'حدث خطأ غير متوقع',
  confirmDeleteLogo: 'هل أنت متأكد من حذف الشعار؟',
  logoDeleteSuccess: 'تم حذف الشعار بنجاح',
  logoDeleteSuccessDetail: 'تم حذف الشعار من التطبيق و Supabase',
  logoDeleteFailed: 'فشل حذف الشعار',
  logoDeleteError: 'حدث خطأ أثناء حذف الشعار',
  logoPreviewHint: 'انقر لتغيير الشعار',
  changeLogo: 'تغيير الشعار',
  chooseFile: 'اختر ملفاً',
  dataSourceActivated: 'تم تفعيل مصدر البيانات: {{id}}',
  dataSourceActivatedReload: 'تم تفعيل المصدر {{id}} — جاري إعادة التحميل…',
  sectionLoading: 'جاري التحميل…',
  invoiceResetTitle: 'إعادة تعيين رقم الفاتورة',
  invoiceResetDesc:
    'يُعاد عداد الفاتورة / الموحدة إلى 0 فقط إذا لم تبقَ أي فاتورة — التالي: 001.',
  invoiceResetRun: 'إعادة إلى 001 (إن كان فارغاً)',
  invoiceResetRunning: 'جاري إعادة التعيين…',
  invoiceResetSuccess: 'تمت إعادة عداد الفاتورة إلى صفر — التالي: {{number}}',
  invoiceResetBlockedSales:
    'غير ممكن: تم اكتشاف {{count}} مبيعة حقيقية. لم يُغيَّر رقم الفاتورة.',
  invoiceResetBlockedInvoices:
    'غير ممكن: ما زالت هناك {{count}} فاتورة. استخدم «محاذاة» أو «ضغط».',
  invoiceResetNoBusiness: 'لا توجد مؤسسة نشطة',
  invoiceResetFailed: 'فشل إعادة تعيين رقم الفاتورة',
  sequenceToolsTitle: 'أرقام الشراء / البيع / الفاتورة',
  sequenceToolsDesc:
    'محاذاة = التالي = أعلى موجود + 1. إعادة إلى 001 = فقط إن كان فارغاً. ضغط = سد الفجوات (1…N) مع إعادة ربط آمنة — عبر هذه الأزرار فقط.',
  sequenceToolsRunning: 'جاري المعالجة…',
  sequenceAlignRun: 'محاذاة العدادات',
  sequenceAlignSuccess: 'تمت محاذاة العدادات — التالي: {{next}}',
  sequenceAlignFailed: 'فشل محاذاة العدادات',
  sequenceCompactRun: 'ضغط (سد الفجوات)',
  sequenceCompactConfirm:
    'الضغط سيعيد ترقيم الشراء والبيع والفواتير بدون فجوات (1…N) ويحدّث الدفعات/الفواتير المرتبطة. المتابعة للمعاينة؟',
  sequenceCompactApplyConfirm:
    '{{count}} رقم(أرقام) للتغيير. التالي بعد الضغط: {{next}}. تطبيق الآن؟',
  sequenceCompactNothing: 'لا شيء للضغط: بدون فجوات أو بلا مستندات.',
  sequenceCompactSuccess: 'اكتمل الضغط ({{count}} تغييرات) — التالي: {{next}}',
  sequenceCompactFailed: 'فشل ضغط الأرقام',
  openingCapitalTitle: 'رأس المال الافتتاحي',
  openingCapitalDesc:
    'إجمالي مساهمة المالك (اختياري): نقد + أصول ثابتة. مبلغ واحد فقط.',
  openingCapitalAmount: 'المبلغ',
  openingCapitalDescription: 'وصف (اختياري)',
  openingCapitalSave: 'حفظ رأس المال',
  openingCapitalSaved: 'تم حفظ رأس المال الافتتاحي',
  openingCapitalHint:
    'مثال: رأس مال 1 000 000 منها سيارة 250 000 → أدخل 1 000 000 هنا والسيارة في الأصول الثابتة. البضاعة تبقى عبر المشتريات.',
  openingCapitalRemaining:
    'السيولة المتبقية من رأس المال (بدون الأصول الثابتة): {{amount}} — لا تدخل في رصيد لوحة التحكم ما دام لا توجد مبيعات.',
  fixedAssetsTitle: 'الأصول الثابتة',
  fixedAssetsDesc: 'أصول طويلة الأجل: سيارة، مكتب، رفوف، معدات (اختياري).',
  fixedAssetName: 'الاسم',
  fixedAssetCategory: 'الفئة',
  fixedAssetAmount: 'القيمة',
  fixedAssetAdd: 'إضافة',
  fixedAssetSave: 'حفظ الأصول الثابتة',
  fixedAssetSaved: 'تم حفظ الأصول الثابتة',
  fixedAssetEmpty: 'لا توجد أصول ثابتة',
  fixedAssetTotal: 'إجمالي الأصول الثابتة',
  fixedAssetCatVehicle: 'مركبة',
  fixedAssetCatFurniture: 'أثاث / رفوف',
  fixedAssetCatBuilding: 'محل / مكتب',
  fixedAssetCatEquipment: 'معدات',
  fixedAssetCatOther: 'أخرى',
  openingCapitalFixedWarning:
    'الأصول الثابتة تتجاوز رأس المال الافتتاحي — زد رأس المال أو قلّل الأصول الثابتة.',
  cloudSyncTitle: 'مزامنة السحابة',
  cloudSyncDesc:
    'المزامنة تلقائية بالكامل: متى كان Mirror/Hybrid مفعّلاً وأنت متصل، تُرسل كل البيانات إلى Supabase (بدون صور المنتجات).',
  cloudSyncPlan: 'العرض الحالي',
  cloudSyncPlanNone: 'محلي فقط — فعّل Mirror أو Hybrid للنسخ السحابي التلقائي',
  cloudSyncPlanMirror: 'Cloud Mirror — مزامنة تلقائية لكل البيانات (ما عدا صور المنتجات)',
  cloudSyncPlanHybrid:
    'هجين — Mirror تلقائي + كتالوج متعدد الأجهزة (مزامنة + وقت حقيقي)',
  cloudSyncScope:
    'لا زر مطلوب: تسجيل الدخول، التشغيل، العودة أونلاين وكل تعديل محلي → دفع تلقائي إلى Supabase. الشعار فقط في السحابة؛ صور المنتجات محلية.',
  cloudSyncContactAdmin: 'لتفعيل Cloud Mirror أو Hybrid، تواصل مع مسؤول AMAN.',
  cloudOutboxTitle: 'طابور المزامنة (Outbox)',
  cloudOutboxSummary:
    'قيد الانتظار: {{pending}} · مؤجل (الخطة): {{deferred}} · جاري: {{processing}} · فشل: {{failed}} · تم: {{done}}',
  cloudOutboxIdle: 'لا يوجد انتظار — الطابور فارغ أو الكل متزامن.',
  cloudOutboxUnavailable: 'حالة outbox غير متاحة (IndexedDB).',
  cloudOutboxRefresh: 'تحديث الحالة',
  cloudOutboxDrain: 'إرسال الآن',
  cloudOutboxRetry: 'إعادة المحاولات الفاشلة',
  cloudOutboxWorking: 'مزامنة…',
  cloudOutboxDrainDone: 'اكتمل تفريغ outbox',
  cloudOutboxDrainFailed: 'فشل تفريغ outbox',
  cloudOutboxRetryDone: 'أُعيدت {{count}} عناصر للطابور',
  cloudOutboxRetryFailed: 'فشلت إعادة outbox',
  restaurantTablesTitle: 'طاولات المطعم',
  restaurantTablesDesc:
    'طاولات خدمة Sur place في نقطة البيع. الطاولات غير النشطة لا تظهر في القاعة.',
  restaurantTablesAdd: 'إضافة طاولة',
  restaurantTablesLabel: 'الاسم',
  restaurantTablesSeats: 'المقاعد',
  restaurantTablesActive: 'نشطة',
  restaurantTablesSave: 'حفظ الطاولات',
  restaurantTablesSaved: 'تم حفظ الطاولات',
  restaurantTablesEmpty: 'لا طاولات — يُنشأ T1–T12 عند أول تحميل للمطعم.',
  restaurantTablesRemove: 'إزالة',
  cloudLinkStatus: 'ربط السحابة',
  cloudLinkLinked: 'الحساب مربوط بـ Supabase — ظاهر للمسؤول',
  cloudLinkLocalOnly: 'محلي فقط — ليس بعد في Supabase',
  cloudUpgradeHint:
    'ينشئ حساب Auth وطلب موافقة في Supabase. بعدها يوافق المسؤول ويفعّل Mirror أو Hybrid. البيانات المحلية تبقى كما هي.',
  cloudUpgradePassword: 'كلمة مرور الحساب (تأكيد)',
  cloudUpgradePasswordPlaceholder: 'كلمة مرور تسجيل الدخول',
  cloudUpgradeRun: 'Upgrade Cloud',
  cloudUpgradeRunning: 'جاري الربط بالسحابة…',
  cloudUpgradeSuccess: 'تم إنشاء الحساب السحابي — بانتظار موافقة المسؤول',
  cloudUpgradePendingEmail:
    'تم إنشاء حساب Auth — أكّد البريد إن لزم، ثم يستطيع المسؤول الموافقة',
  cloudUpgradeAlreadyLinked: 'هذا الحساب مربوط بالسحابة مسبقاً',
  cloudUpgradeFailed: 'فشل ترقية السحابة',
  cloudUpgradeErrOffline: 'يلزم اتصال بالإنترنت — تحقق من الشبكة / VPN ثم أعد المحاولة',
  cloudUpgradeErrPassword: 'كلمة المرور غير صحيحة',
  cloudUpgradeErrPasswordRequired: 'أدخل كلمة مرور الحساب',
  cloudUpgradeErrConfig: 'Supabase غير مُعدّ في التطبيق',
  cloudUpgradeErrNotFound:
    'الحساب المحلي غير موجود — سجّل الدخول بحساب المؤسسة ثم أعد المحاولة',
  cloudUpgradeErrIdentity:
    'البريد أو اسم المستخدم ناقص في الحساب المحلي — أكمل التسجيل / الملف',
  cloudPlanRefresh: 'تحديث عرض السحابة',
  cloudPlanRefreshing: 'جاري التحديث…',
  cloudPlanRefreshed: 'تم تحديث عرض السحابة من Supabase',
  cloudPlanRefreshFailed: 'تعذّر تحديث عرض السحابة'
};
